import styled from "styled-components";
import { UserDeleteOutlined } from "@ant-design/icons";
import { SystemDescriptions } from "src/common/descriptions/descriptions";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 80px 20px;
  color: #4a4a4a;
`;

const IconContainer = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #f3f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  .anticon {
    font-size: 48px;
    color: #9ca3af;
  }
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
`;

const Message = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  max-width: 420px;
  margin: 0 auto 24px;
`;

const AddButton = styled.button`
  background: #2563eb;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);
  transition: background 0.2s, transform 0.1s;

  &:hover {
    background: #1d4ed8;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

interface Props {
  callToAction?: () => void;
}

export default function EmptyPatientsState(props: Props) {
  const descriptions = SystemDescriptions.COMPONENTS.PATIENT_SEARCH

  const handleAddPatient = () => {
    props.callToAction?.();
  };

  return (
    <Wrapper>
      <IconContainer>
        <UserDeleteOutlined />
      </IconContainer>
      <Title>{descriptions.SEARCH_RESULTS.EMPTY_STATE.TITLE}</Title>
      <Message>
        {descriptions.SEARCH_RESULTS.EMPTY_STATE.DESCRIPTION}
      </Message>
      {
        props.callToAction &&
        <AddButton onClick={handleAddPatient}>+ Add New Patient</AddButton>
      }
    </Wrapper>
  );
}